module.exports = __webpack_public_path__ + "de4b7bfe12009d109f624f9d32ea4db8.mp4";